export default {"src":"/_next/static/media/boba.2072e50b.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};